// Options for the "Recruiter" filter on list pages.
//
// The list endpoints return `authors` — the people who actually created the rows
// the current user can see. That deliberately includes SuperAdmins, Developers
// and DEACTIVATED users, because their records are still on the page and have to
// stay filterable. Inactive authors are labelled rather than hidden, so it's
// obvious why an unfamiliar name is in the list.
const ROLE_LABEL = {
  SuperAdmin:       'Admin',
  RecruiterManager: 'Manager',
  Recruiter:        'Recruiter',
  Developer:        'Developer',
};

export const authorOptions = (authors = []) =>
  authors.map(u => ({
    value: u.id,
    label: u.name,
    sub: `${ROLE_LABEL[u.role] || u.role || ''}${u.isActive === false ? ' · Inactive' : ''}`,
  }));
